import { render, staticRenderFns } from "./AtendimentosDomiciliares.vue?vue&type=template&id=0c5e1c3f"
import script from "./AtendimentosDomiciliares.vue?vue&type=script&lang=js"
export * from "./AtendimentosDomiciliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports